import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

// Function to automatically import all modules
function loadModules() {
  const context = require.context('./modules', false, /\.js$/)
  const modules = {}

  context.keys().forEach(file => {
    // Get module name from filename
    const moduleName = file.replace(/(\.\/|\.js)/g, '')
    // Register module
    modules[moduleName] = context(file).default
  })

  return modules
}

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    ...loadModules(),
  },
  strict: process.env.DEV,
})
